import AppLayout from "Layout/Layout";
import { NonIndexRouteObject } from "react-router";
import { getResourcePath } from "./constant";
import { ListPage } from "pages/doi-tuong-vi-pham/list-page";
import { DetailPage } from "pages/doi-tuong-vi-pham/detail-page";
import { EditPage } from "pages/doi-tuong-vi-pham/edit-page";
import { CreatePage } from "pages/doi-tuong-vi-pham/create-page";

export const quanLyDoiTuongViPhamRouters: NonIndexRouteObject[] = [
  {
    path: getResourcePath("doi-tuong-vi-pham", "list"),
    element: (
      <AppLayout>
        <ListPage />
      </AppLayout>
    ),
  },
  {
    path: getResourcePath("doi-tuong-vi-pham", "detail"),
    element: (
      <AppLayout>
        <DetailPage />
      </AppLayout>
    ),
  },
  {
    path: getResourcePath("doi-tuong-vi-pham", "edit"),
    element: (
      <AppLayout>
        <EditPage />
      </AppLayout>
    ),
  },
  {
    path: getResourcePath("doi-tuong-vi-pham", "create"),
    element: (
      <AppLayout>
        <CreatePage />
      </AppLayout>
    ),
  },
];
